// Shown wherever a fare is displayed: fares exclude toll tax.
const TollNote = ({ style, className = "" }) => (
    <small className={`toll-note ${className}`.trim()} style={{ display: "block", fontSize: 11.5, fontWeight: 600, color: "#94a3b8", ...style }}>
        <i className="fas fa-road" style={{ marginRight: 4 }}></i>Toll tax not included
    </small>
);

export default TollNote;
